const initialState = {
  isSelectorOpen: false
}

const payment = (state = initialState, action) => {
  switch (action.type) {
    case  'SHOP.CHARGE':
      return {...state, isSelectorOpen: true}
    case 'OPEN_ORDER.NAME_CONFIRMED':
    case 'PAYMENT_MODAL_CLOSED':
      return {...state, isSelectorOpen: false}
    case 'SIGNATURE.START':
      return {...state, signature: action.payload }
    case 'SIGNATURE.STOP':
      return {...state, signature: null }
    case 'SIGNATURE.COMPLETE':
      return {...state, signature: {...state.signature, error: null} }
    case 'PAYMENT_ERROR':
      if (_.isEmpty(state) || !state.signature) return state

      return {...state, signature: {...state.signature, error: action.payload.error} }
    case 'PAYMENT_SUCCESS':
      if (_.isEmpty(state) || !state.signature) return {...state, isSelectorOpen: false}

      return { ...state, signature: null, isSelectorOpen: false }
    default:
      return state
  }
}

export default payment
